/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateUserOptions,
  CreateUserStatus201,
  CreateUserStatus400,
  CreateUserStatus409,
  CreateUserStatus500,
} from '../types/CreateUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createUser } from '../clients/createUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createUserMutationKey = () => [{ url: '/v1/user' }] as const

export function createUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createUserMutationKey()
  return mutationOptions<
    CreateUserStatus201,
    ResponseErrorConfig<CreateUserStatus400 | CreateUserStatus409 | CreateUserStatus500>,
    CreateUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createUser({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new user
 * {@link /v1/user}
 */
export function useCreateUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateUserStatus201,
      ResponseErrorConfig<CreateUserStatus400 | CreateUserStatus409 | CreateUserStatus500>,
      CreateUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createUserMutationKey()

  const baseOptions = createUserMutationOptions(config) as UseMutationOptions<
    CreateUserStatus201,
    ResponseErrorConfig<CreateUserStatus400 | CreateUserStatus409 | CreateUserStatus500>,
    CreateUserOptions,
    TContext
  >

  return useMutation<
    CreateUserStatus201,
    ResponseErrorConfig<CreateUserStatus400 | CreateUserStatus409 | CreateUserStatus500>,
    CreateUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateUserStatus201,
    ResponseErrorConfig<CreateUserStatus400 | CreateUserStatus409 | CreateUserStatus500>,
    CreateUserOptions,
    TContext
  >
}
